import { useFormikContext } from 'formik';
import React from 'react';
import { ShareLinkFormType } from '../link-config-form.factory';
import { SharePanelFormSection } from './section';

export const SharePanelFormPresentationSection = () => {
  const { values } = useFormikContext<ShareLinkFormType>();

  return (
    <SharePanelFormSection
      type='presentation'
      title='Journey view mode'
      subTitle={`View mode is ${values.presentation_mode ? 'presentation' : 'standard'}`}
    />
  );
};
